export const initBlockData = {
  title: "Sample text",
};

export const initEmptyBlockData = {
  title: "",
};
